import { render, staticRenderFns } from "./PartWaterQualityMinuteRecordList.vue?vue&type=template&id=b86b9ef4"
import script from "./PartWaterQualityMinuteRecordList.vue?vue&type=script&lang=js"
export * from "./PartWaterQualityMinuteRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports